import { render, staticRenderFns } from "./AllowanceBreakdownInput.vue?vue&type=template&id=04116a8a"
import script from "./AllowanceBreakdownInput.vue?vue&type=script&lang=js"
export * from "./AllowanceBreakdownInput.vue?vue&type=script&lang=js"
import style0 from "./AllowanceBreakdownInput.vue?vue&type=style&index=0&id=04116a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports